import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    SurveyCreateVariantResponseT,
    SurveyGetSurveyResponseT,
    SurveyPayloadT,
    SurveysCreateResponseT,
    SurveysExcelResponseT,
    SurveysGetListResponseT,
    SurveyUpdatePayloadT,
    SurveyUpdateVariantResponseT,
    VariantPayloadT,
} from '../types/survey.types'

export class SurveysRepository {
    getList(page: number): Promise<AxiosResponse<SurveysGetListResponseT>> {
        const params = {
            page,
        }

        return http.get('/survey/api/admin/surveys', { params })
    }

    deleteSurvey(survey_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/survey/api/admin/surveys/${survey_id}`)
    }

    deleteVariant(survey_id: number, variant_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/survey/api/admin/survey/${survey_id}/variants/${variant_id}`)
    }

    createSurvey(payload: SurveyPayloadT): Promise<AxiosResponse<SurveysCreateResponseT>> {
        return http.post('/survey/api/admin/surveys', payload)
    }

    updateSurvey(survey_id: number, payload: SurveyUpdatePayloadT): Promise<AxiosResponse<void>> {
        return http.put(`/survey/api/admin/surveys/${survey_id}`, payload)
    }

    getSurvey(survey_id: number): Promise<AxiosResponse<SurveyGetSurveyResponseT>> {
        return http.get(`/survey/api/admin/surveys/${survey_id}`)
    }

    createVariant(
        survey_id: number,
        payload: VariantPayloadT
    ): Promise<AxiosResponse<SurveyCreateVariantResponseT>> {
        return http.post(`/survey/api/admin/survey/${survey_id}/variants`, payload)
    }

    updateVariant(
        survey_id: number,
        variant_id: number,
        payload: VariantPayloadT
    ): Promise<AxiosResponse<SurveyUpdateVariantResponseT>> {
        return http.put(`/survey/api/admin/survey/${survey_id}/variants/${variant_id}`, payload)
    }

    exportExcel(): Promise<AxiosResponse<SurveysExcelResponseT>> {
        return http.get('/survey/api/admin/surveys/export/surveys', { responseType: 'blob' })
    }
}
